"use client";

import { useViewport } from "@faire/web/ui/hooks/useViewport";
import React from "react";

import { InsiderBadge } from "@faire/retailer/components/InsiderBadge/InsiderBadge";

interface ITileBadgeProps {
  className?: string;
  hasFreeDuties?: boolean;
  hasFreeShipping?: boolean;
  insiderBadgeText?: string;
}

export const TileBadge: React.FC<ITileBadgeProps> = ({
  className,
  hasFreeDuties,
  hasFreeShipping,
  insiderBadgeText,
}) => {
  const showShortenedText = useViewport().isTabletAndBelow;

  return (
    <InsiderBadge
      className={className}
      showShortText={showShortenedText}
      showFreeDuties={hasFreeDuties}
      showFreeShipping={hasFreeShipping}
      insiderBadgeText={insiderBadgeText}
    />
  );
};
